import React from "react";
import "./App.css";
import AppRoutes from "./routes";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import useTokenRefresh from "./hooks/useTokenRefresh";
import { GlobalStyle } from "./styles/global";
import { BookingQuoteContextProvider } from "./context/BookingContextProvider";
import { SearchProvider } from "./context/SearchFilterContext";
import { GoogleMapsLoader } from "./services/googleMapsLoader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  useTokenRefresh();

  return (
    <ThemeProvider>
      <GlobalStyle />
      <ToastContainer position="top-right" autoClose={5000} />
      <AuthProvider>
        <GoogleMapsLoader>
          <SearchProvider>
            <BookingQuoteContextProvider>
              <AppRoutes />
            </BookingQuoteContextProvider>
          </SearchProvider>
        </GoogleMapsLoader>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
